<style lang="less">
@import "../less/common.less";
@import "./productABC.less";
</style>
<template>
  <el-row id="productABC"
          type="flex"
          :gutter="20"
          class="productABC row-bg common-layout"
          justify="space-between">
    <el-col class="common-layout-r"
            id="search-content-h"
            :span="24">
      <div class="search-txt">
        <el-form :label-position="labelPosition"
                 label-width="80px"
                 :model="formLabelAlign">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="日期:"
                            class="common-date-picker">
                <el-date-picker v-model="startTime"
                                type="date"
                                placeholder="开始日期"
                                :picker-options="pickerOptionsStart"
                                :clearable="false"
                                :editable="false"
                                size="medium"
                                @change="changeStart"></el-date-picker>
                <el-date-picker v-model="endTime"
                                type="date"
                                placeholder="结束日期"
                                :picker-options="pickerOptionsEnd"
                                @change="changeEnd"
                                :editable="false"
                                size="medium"
                                :clearable="false"></el-date-picker>
                <div class="picker-ico">至</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="区域:">
                <template v-if="deptAreaList.length">
                  <el-select v-model="areaId"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeArea">
                    <el-option v-for="item in deptAreaList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeArea">
                    <el-option v-for="item in deptAreaList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="门店:">
                <template v-if="optionsDept.length">
                  <el-select v-model="valueDept"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectDeptAll">
                    <el-option v-for="item in optionsDept"
                               :key="item.deptId"
                               :label="item.deptName"
                               :value="item.deptId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectDeptAll">
                    <el-option v-for="item in optionsDept"
                               :key="item.deptId"
                               :label="item.deptName"
                               :value="item.deptId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    class="btn-filter">
              <el-form-item class="radio-type">
                <el-radio v-model="radio"
                          size="medium"
                          :label="0">小类累计</el-radio>
                <el-radio v-model="radio"
                          size="medium"
                          :label="1">全部累计</el-radio>

              </el-form-item>
              <el-button class="save-abc"
                         type="text"
                         size="small"
                         @click="saveABC">
                <div>保存综合ABC</div>
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- <el-col :span="6">
              <el-form-item label="商品分类:">
                <el-select v-model="valueProductType"
                           collapse-tags
                           filterable
                           multiple
                           placeholder="请选择"
                           :clearable="true"
                           @change="selectAll">
                  <el-option v-for="item in optionsProductType"
                             :key="item.productTypeId"
                             :label="item.productTypeName"
                             :value="item.productTypeId"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="中类:">
                <template v-if="typeList1.length">
                  <el-select v-model="productTypeId1"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeProductType1">
                    <el-option v-for="item in typeList1"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             size="medium"
                             @change="changeProductType1">
                    <el-option v-for="item in typeList1"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="小类:">
                <template v-if="optionsProductType.length">
                  <el-select v-model="valueProductType"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectAll">
                    <el-option v-for="item in optionsProductType"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             :clearable="true"
                             size="medium"
                             @change="selectAll">
                    <el-option v-for="item in optionsProductType"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="商品分类:">
                <el-select v-model="valueProductType"
                           collapse-tags
                           filterable
                           multiple
                           placeholder="请选择"
                           :clearable="true"
                           @change="selectAll">
                  <el-option v-for="item in optionsProductType"
                             :key="item.productTypeId"
                             :label="item.productTypeName"
                             :value="item.productTypeId"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="报废类型:">
                <el-select v-model="valueSysCode"
                           collapse-tags
                           filterable
                           multiple
                           placeholder="请选择"
                           size="medium"
                           :clearable="true">
                  <el-option v-for="item in optionsSysCode"
                             :key="item.id"
                             :label="item.codeValue"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="建议:">
                <el-select v-model="valueRecommend"
                           filterable
                           size="medium"
                           placeholder="请选择">
                  <el-option v-for="item in optionsRecommend"
                             :key="item.Id"
                             :label="item.name"
                             :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item class="check-btn">
                <el-checkbox v-model="checkedBQ"
                             @change="getProductBQ">显示商品标签</el-checkbox>
                <el-button class="export"
                           @click="exportExcel">导出</el-button>
                <el-button type="primary"
                           @click="getDataList(true)">搜索</el-button>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row :gutter="20">
            <el-col :span="18"
                    class="check-bq">
              <el-checkbox v-model="checkedBQ"
                           size="medium"
                           @change="getProductBQ">显示商品标签</el-checkbox>
              <el-button v-allow="'Intelligent.ProductABC.Set'"
                         class="save-abc"
                         type="text"
                         size="small"
                         @click="saveSet">
                <div>设置</div>
              </el-button>
            </el-col>
            <el-col :span="6">
              <el-form-item class="check-btn">
                <el-button class="export"
                           size="small"
                           @click="exportExcel">导出</el-button>
                <el-button type="primary"
                           size="small"
                           @click="getDataList(true)">搜索</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="search-content">
        <div class="tip-txt"
             type="text">注：双击商品名称展示产品曲线图，双击过期报废展示过期报废占比，双击毛利展示毛利占比</div>
        <el-table class="table-common table-roll"
                  :data="tableData"
                  border
                  style="width: 100%"
                  :height="height"
                  :row-class-name="tableRowClassName"
                  :cell-style="cellStyle"
                  :resizable="false"
                  v-loading="pictLoading"
                  element-loading-background="rgba(255, 255, 255, 0.5)"
                  element-loading-text="拼命加载中"
                  element-loading-spinner="el-icon-loading"
                  id="out-table">
          <el-table-column label-class-name="product-data-index"
                           type="index"
                           label
                           align="center"
                           fixed
                           width="50"></el-table-column>
          <el-table-column fixed
                           prop="PRODUCT_TYPE_NAME"
                           width="120"
                           label="商品分类"
                           header-align="center">
            <template slot-scope="scope">
              <el-popover trigger="hover"
                          open-delay="200"
                          placement="top">
                <p>{{ scope.row.PRODUCT_TYPE_NAME }}</p>
                <div slot="reference"
                     class="name-wrapper"
                     @dblclick="showProductTypeInfo(scope.row)">{{ scope.row.PRODUCT_TYPE_NAME }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column fixed
                           prop="Product_Code"
                           width="100"
                           label="编码"
                           header-align="center"></el-table-column>
          <el-table-column fixed
                           prop="Product_Name"
                           width="120"
                           label="商品名称"
                           header-align="center">
            <template slot-scope="scope">
              <el-popover trigger="hover"
                          open-delay="200"
                          placement="top">
                <p>{{ scope.row.Product_Name }}</p>

                <div slot="reference"
                     class="name-wrapper"
                     @dblclick="showProductInfo(scope.row)">{{ scope.row.Product_Name }}
                  <div class="new-tips"
                       v-if="scope.row.IsNew=='1'">新</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column fixed
                           prop="Product_Price"
                           width="100"
                           label="销售价"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="Product_OutPrice"
                           width="100"
                           label="成本价"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="Product_OutPriceAmount"
                           width="100"
                           label="成本总额"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="XS_Amount"
                           width="100"
                           label="销售量"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="XS_AverAmount"
                           width="100"
                           label="店均量"
                           header-align="center"
                           sortable
                           align="right">
            <template slot-scope="scope">
              <p>{{Math.trunc(scope.row.XS_AverAmount)}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="XS_Money"
                           width="100"
                           label="销售金额"
                           header-align="center"
                           sortable
                           align="right"></el-table-column>
          <el-table-column prop="Amount_Rate"
                           width="100"
                           label="数量占比"
                           header-align="center"
                           sortable
                           sort-by="Amount_Rate2"
                           align="right"></el-table-column>
          <el-table-column prop="Amount_Rate_Total"
                           width="130"
                           label="数量累计占比"
                           header-align="center"
                           sortable
                           sort-by="Amount_Rate_Total2"
                           align="right"></el-table-column>
          <el-table-column prop="XS_Money_Rate"
                           width="100"
                           label="金额占比"
                           header-align="center"
                           sortable
                           sort-by="XS_Money_Rate2"
                           align="right"></el-table-column>
          <el-table-column prop="XS_Money_Rate_Total"
                           width="130"
                           label="金额累计占比"
                           header-align="center"
                           sortable
                           sort-by="XS_Money_Rate_Total2"
                           align="right"></el-table-column>
          <el-table-column prop="XS_ABC_Rate"
                           width="80"
                           label="销售ABC"
                           align="center"
                           header-align="center"></el-table-column>
          <el-table-column prop="RebateMoney"
                           width="100"
                           label="优惠金额"
                           header-align="center"
                           sortable
                           align="right">
          </el-table-column>
          <el-table-column :prop="item.id"
                           width="120"
                           :label="item.codeValue+'(%)'"
                           align="center"
                           header-align="center"
                           sortable
                           :sort-by="item.id+'&&'"
                           v-for="(item,index) in valueSysCodeColumn"
                           :key="index">
            <template slot-scope="scope">
              <div slot="reference"
                   class="name-wrapper"
                   @dblclick="showOverdue(scope.row,item.codeValue,item)">{{ scope.row[item.id] }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="XS_Profit"
                           width="100"
                           label="销售毛利"
                           header-align="center"
                           sortable
                           align="right">
          </el-table-column>
          <el-table-column prop="XS_Profit_Rate"
                           width="120"
                           label="销售毛利率"
                           header-align="center"
                           sortable
                           sort-by="XS_Profit_Rate2"
                           align="right"></el-table-column>
          <el-table-column prop="Profit"
                           width="100"
                           label="毛利"
                           header-align="center"
                           sortable
                           align="right">
            <template slot-scope="scope">
              <div slot="reference"
                   class="name-wrapper"
                   @dblclick="showProfitRate(scope.row)">{{ scope.row.Profit }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="Profit_Rate"
                           width="100"
                           label="毛利率"
                           header-align="center"
                           sortable
                           sort-by="Profit_Rate2"
                           align="right"></el-table-column>
          <el-table-column prop="ProfitABC_Rate"
                           width="120"
                           :label="setABC==1?'销售毛利率ABC':'毛利率ABC'"
                           header-align="center"></el-table-column>
          <el-table-column prop="Compose_ABC_Rate"
                           width="80"
                           label="综合ABC"
                           header-align="center"></el-table-column>
          <el-table-column prop="Recommend"
                           width="100"
                           label="建议"
                           header-align="center"></el-table-column>
          <template v-if="checkedBQ">
            <el-table-column header-align="center"
                             v-for="item in columnsList"
                             :key="item.field"
                             :prop="item.field"
                             width="100"
                             :label="item.title"></el-table-column>
          </template>
        </el-table>
      </div>
      <el-dialog class="exportDialog"
                 :visible.sync="centerDialogVisible"
                 width="30%"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :show-close="false"
                 :modal-append-to-body="false"
                 center>
        <el-progress class="exportProgress"
                     :text-inside="false"
                     :show-text="false"
                     :stroke-width="16"
                     :percentage="percentage"></el-progress>
        <p>{{percenttxt}}</p>
      </el-dialog>

      <!--  产品弹出框信息 start -->
      <el-dialog id="productDialogID"
                 class="productDialog"
                 :title="productName"
                 :visible.sync="productDialogVisible"
                 width="70%"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :modal-append-to-body="false">
        <div>
          <div class="productHeader">
            <h3 class="titleName">时段分析</h3>
            <el-tabs v-model="activeName"
                     @tab-click="handleClick">
              <el-tab-pane label="天"
                           name="first">默认值:当前时间前一天前推30天数据</el-tab-pane>
              <el-tab-pane label="月"
                           name="second">默认值:当前月前一个月前推12个月数据</el-tab-pane>
              <el-tab-pane label="自定义"
                           name="third">&nbsp;</el-tab-pane>
            </el-tabs>
            <div class="product-date-picker">
              <template v-if="activeName=='third'">
                <el-date-picker v-model="startTimeProduct"
                                type="date"
                                placeholder="开始日期"
                                :picker-options="productOptionsStart"
                                :clearable="false"
                                :editable="false"
                                size="medium"
                                @change="changeProductStart"></el-date-picker>
                <div class="picker-ico">至</div>
                <el-date-picker v-model="endTimeProduct"
                                type="date"
                                placeholder="结束日期"
                                :picker-options="productOptionsEnd"
                                @change="changeProductEnd"
                                :editable="false"
                                size="medium"
                                :clearable="false"></el-date-picker>
              </template>
              <template v-if="activeName=='second'">
                <el-date-picker v-model="startMonthProduct"
                                type="month"
                                placeholder="开始月"
                                :picker-options="monthOptionsStart"
                                @change="changeMonthStart"
                                :editable="false"
                                size="medium"
                                :clearable="false"></el-date-picker>

                <div class="picker-ico">至</div>
                <el-date-picker v-model="endMonthProduct"
                                type="month"
                                placeholder="结束月"
                                :picker-options="monthOptionsEnd"
                                @change="changeMonthEnd"
                                :editable="false"
                                size="medium"
                                :clearable="false"></el-date-picker>
              </template>
            </div>
            <div class="comperProduct"
                 v-if="tableData.length>1">
              <label>对比产品:</label>
              <el-select class="comperProductSelect"
                         v-model="valueComperProduct"
                         filterable
                         multiple
                         :multiple-limit="10"
                         collapse-tags
                         placeholder="请选择"
                         :clearable="true"
                         size="medium"
                         @change="changeComperPro">
                <el-option v-for="item in tableData"
                           :key="item.ID"
                           :label="item.Product_Name"
                           :value="item.ID"
                           v-if="ID!=item.ID"></el-option>
              </el-select>
            </div>
          </div>
          <div class="productTypeS">
            <el-radio-group v-model="resType"
                            @change="resTypeChange">
              <el-radio :label="0">金额</el-radio>
              <el-radio :label="1">数量</el-radio>
              <el-radio :label="2">店均数量</el-radio>
            </el-radio-group>
          </div>
          <div id="myChart"
               :style="{height: '400px',width: widthPro+'px'}"></div>
        </div>
      </el-dialog>
      <!--  产品弹出框信息 end -->
    </el-col>
    <!-- 过期占比弹出框 start -->
    <overdueABC :productName="productNameCurrent"
                :beginDate="beginDateCurrent"
                :endDate="endDateCurrent"
                :productId="productIdCurrent"
                :deptId="deptIdCurrent"
                :returnTypeId="returnTypeIdCurrent"
                :overdueDialogVisible="overdueDialog"
                @close_overdue="closeOverdue"></overdueABC>
    <!-- 过期占比弹出框 end -->
    <!-- 毛利占比弹出框 start -->
    <profitRateABC :productName="productNameCurrent"
                   :beginDate="beginDateCurrent"
                   :endDate="endDateCurrent"
                   :productId="productIdCurrent"
                   :deptId="deptIdCurrent"
                   :profitRateDialog="profitRateDialog"
                   @close_profitRate="closeProfitRate"></profitRateABC>
    <!-- 毛利占比弹出框 end -->
    <!-- 产品类型弹出框信息 start -->
    <productType :productTypeName="productTypeNameCurrent"
                 :beginDate="beginDateCurrent"
                 :endDate="endDateCurrent"
                 :productTypeId="productTypeIdCurrent"
                 :deptId="deptIdCurrent"
                 :productTypeDialogVisible="productTypeDialogVisible"
                 @close_ProductTypeInfo="closeProductTypeInfo">
    </productType>
    <!-- 产品类型弹出框信息 end -->
    <!--  设置综合ABC start -->
    <el-dialog id="productDialogID"
               class="productSetABCDialog"
               title="设置-综合ABC"
               :visible.sync="productSetDialogVisible"
               width="70%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :modal-append-to-body="false"
               :show-close="false">
      <div>
        <!-- <div class="productHeader">
          综合ABC
      </div> -->
        <el-radio-group v-model="setABC">
          <el-radio :label="0">毛利率</el-radio>
          <el-radio :label="1">销售毛利率</el-radio>
        </el-radio-group>
        <div slot="footer"
             class="dialog-footer">
          <!-- type="primary" -->
          <el-button size="small"
                     @click="closeSetABC">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  设置综合ABC end -->
  </el-row>
</template>
<script>
import deptApi from "@/api/api-dept";
import productApi from "@/api/api-product";
import common from "@/libs/common";
import $ from "jquery";
import { Message, MessageBox } from "element-ui";
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
import profitRateABC from './profitRateABC.vue'
import overdueABC from './overdueABC.vue'
import productType from './productType.vue'

let loading;
let loading1;
let loading2;
let myChart;
export default {
  components: {
    profitRateABC,
    overdueABC,
    productType
  },
  data () {
    return {
      // 设置综合ABC
      productSetDialogVisible: false,
      setABC: 0,
      // 产品分类弹出框信息
      productTypeDialogVisible: false,
      productTypeIdCurrent: null,
      // productTypeName: null,
      // 产品弹出框信息start
      productDialogVisible: false,
      productName: null,
      ID: null,
      currentOption: null,
      activeName: "first",
      // 导出弹框
      centerDialogVisible: false,
      percentage: 0,
      percenttxt: "导出数据100条,已处理50条,正在导出,请稍等",
      pictLoading: false,
      //商品ABC对应分类列表
      optionsProductType: [],
      valueProductType: [],
      //获取商品ABC对应报废类型
      optionsSysCode: [],
      valueSysCode: [],
      //建议
      optionsRecommend: [
        { Id: "All", name: "全部" },
        { Id: "0", name: "主推" },
        { Id: "1", name: "保持" },
        { Id: "2", name: "促销" },
        { Id: "3", name: "淘汰" },
        { Id: "4", name: "调整" }
      ],
      valueRecommend: "全部",
      //时间
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      startTime: new Date(common.getPerDate()),
      endTime: new Date(common.getPerDate()),
      //月
      value2: "",
      //日期
      productOptionsStart: {},
      productOptionsEnd: {},
      startTimeProduct: common.getCPerDate(new Date(), 30),
      endTimeProduct: common.getPerDate(),
      // 月
      monthOptionsStart: {},
      monthOptionsEnd: {},
      startMonthProduct: null,
      endMonthProduct: null,

      valueComperProduct: [],
      widthPro: 600,
      legendData: [],
      xAxisData: [],
      seriesData: [],

      labelPosition: "right",
      formLabelAlign: {
        name: "",
        region: "",
        type: ""
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      radio: 1,
      tableData: [],
      valueSysCodeColumn: [],
      checkedBQ: false,
      columnsList: [],
      strProduct: [],
      ListDataItem: [],
      height: $("#search-content-h").height() - 220, // 记录展示那条折线信息
      oldSearchType: [],
      oldSearchDeptType: ["all"],
      optionsDept: [],
      valueDept: [],
      deptAreaList: [], // 0产品数量 1销售数量 2销售金额
      oldDeptArea: ["all"],
      oldDept: ["all"],
      typeList1: [],
      productTypeId1: [],
      oldProductType1: ["all"],
      // 区域
      areaId: ['all'],
      currentDept: [],
      overdueDialog: false, // 过期报废弹出框是否展示
      profitRateDialog: false, // 毛利占比弹出框是否展示
      // 当前查询结果的查询条件 start
      beginDateCurrent: null,
      endDateCurrent: null,
      productIdCurrent: null,
      deptIdCurrent: null,
      returnTypeIdCurrent: null,
      productNameCurrent: null,
      productTypeNameCurrent: null,
      // 当前查询结果的查询条件 end
      resType: 0 // 20201228双击商品名称弹出框折线图新增类型查询
    };
  },
  methods: {
    // 设置综合ABC 关闭弹框
    closeSetABC () {
      let that = this
      that.productSetDialogVisible = false
      that.getDataList(true)
    },
    // 设置综合ABC 打开弹窗
    saveSet () {
      this.productSetDialogVisible = true
    },
    // resType 0金额 1数量 2店均量
    resTypeChange () {
      this.showProductInfo([], true);
    },
    // 报废占比弹出框
    showOverdue (row, codeValue, item) {
      // if (codeValue === '过期报废') {
      let that = this
      // console.log('tab', JSON.stringify(row))
      that.productIdCurrent = row.ID
      that.productNameCurrent = row.Product_Name
      that.returnTypeIdCurrent = item.id
      that.overdueDialog = true
      // }
    },
    closeOverdue () {
      this.overdueDialog = false
    },
    // 利率占比弹出框
    showProfitRate (row) {
      this.productIdCurrent = row.ID
      this.productNameCurrent = row.Product_Name
      this.profitRateDialog = true
    },
    closeProfitRate () {
      this.profitRateDialog = false
    },
    // 切换中类 重新请求数据
    changeProductType1 (val) {
      let that = this
      const allValues = [];
      for (const item of that.typeList1) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        that.oldProductType1.length === 1 ? that.oldProductType1[0] : [];
      if (val.includes("all")) that.productTypeId1 = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.productTypeId1 = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.productTypeId1 = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.productTypeId1 = ["all"].concat(val)
      }
      that.oldProductType1[0] = that.productTypeId1;
      if (that.productTypeId1.length == 0) {
        that.valueProductType = [] // 当前选中分类
        that.optionsProductType = [] // 当前分类列表
        that.oldSearchType = []
      } else {
        let data = { TypeFlag: 0 }
        if (that.productTypeId1[0] !== 'all') { data["typeId"] = that.productTypeId1 }
        common.getProductTypeListByFLag(data).then(
          res => {
            that.optionsProductType = [{ productTypeId: "all", productTypeName: "全选" }].concat(res)
            that.valueProductType = that.optionsProductType.map(item => {
              return item.productTypeId
            })
            that.oldSearchType = ['all']
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    //保存综合ABC功能
    saveABC () {
      let that = this
      if (!that.currentDept || that.currentDept.length == 0 || !that.tableData || that.tableData.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先查询商品ABC信息，再进行保存！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return false
      }
      loading2 = that.$loading({
        lock: true,
        text: "综合ABC保存中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector("#productABC")
      });
      let data = {
        "deptId": that.currentDept,
        "item": that.tableData.map(item => {
          return {
            "productId": item.ID,
            "salesABC": item.XS_ABC_Rate,
            "profitABC": item.ProfitABC_Rate,
            "sumABC": item.Compose_ABC_Rate
          }
        })
      }
      that.saveABCFun(data).then(
        res => {
          if (res && res.res) {
            Message({
              message: "保存成功！",
              type: "success"
            });
          } else {
            Message({
              message: "保存失败！",
              type: "error"
            });
          }
          that.$nextTick(() => {
            loading2.close();
          });
        }, err => {
          that.$nextTick(() => {
            loading2.close();
          });
          console.log('保存综合ABC失败', err)
        })
    },
    // 切换区域，根据区域获取门店 重新请求数据
    changeArea (val) {
      let that = this
      const allValues = [];
      for (const item of that.deptAreaList) {
        allValues.push(item.id);
      }
      const oldVal =
        that.oldDeptArea.length === 1 ? that.oldDeptArea[0] : [];
      if (val.includes("all")) that.areaId = allValues
      if (oldVal.includes("all") && !val.includes("all"))
        that.areaId = []
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.areaId = val
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.areaId = ["all"].concat(val)
      }
      that.oldDeptArea[0] = that.areaId;

      if (that.areaId.length == 0) {
        that.valueDept = [] // 门店
        that.productTypeId1 = [] // 中类
        that.valueProductType = [] // 商品分类
        that.optionsDept = [] // 门店
        that.optionsProductType = [] // 小类
        that.oldSearchDeptType = [] // 门店
        that.oldProductType1 = [] // 中类
        that.oldSearchType = [] // 商品分类
      } else {
        let data = { AreaId: that.areaId[0] === 'all' ? [] : that.areaId }
        common.getDept(data).then(
          res => {
            that.optionsDept = [{ deptId: "all", deptName: "全选" }].concat(res)
            that.valueDept = that.optionsDept.map(item => {
              return item.deptId
            })
            that.oldSearchDeptType = ['all'] // 门店
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    selectDeptAll (val) {
      const allValues = [];
      for (const item of this.optionsDept) {
        allValues.push(item.deptId);
      }
      const oldVal =
        this.oldSearchDeptType.length === 1 ? this.oldSearchDeptType[0] : [];
      if (val.includes("all")) this.valueDept = allValues;
      if (oldVal.includes("all") && !val.includes("all")) this.valueDept = [];
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        this.valueDept = val;
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        console.log(11);
        if (val.length === allValues.length - 1)
          this.valueDept = ["all"].concat(val);
      }
      this.oldSearchDeptType[0] = this.valueDept;
    },
    selectAll (val) {
      const allValues = [];
      for (const item of this.optionsProductType) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        this.oldSearchType.length === 1 ? this.oldSearchType[0] : [];
      if (val.includes("all")) this.valueProductType = allValues;
      if (oldVal.includes("all") && !val.includes("all"))
        this.valueProductType = [];
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        this.valueProductType = val;
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        console.log(11);
        if (val.length === allValues.length - 1)
          this.valueProductType = ["all"].concat(val);
      }
      this.oldSearchType[0] = this.valueProductType;
    },
    // 切换日、月、自定义
    handleClick () {
      let that = this;
      let activeName = that.activeName;

      // 初始化时间控件限制范围
      if (activeName == "first" || activeName == "third") {
        that.startTimeProduct = common.getCPerDate(new Date(), 30);
        that.endTimeProduct = common.getPerDate();
        if (activeName == "third") {
          that.changeProductStart(null);
          that.changeProductEnd(null);
        }
      } else if (activeName == "second") {
        let arr = common.getCPerMonth();
        that.startMonthProduct = new Date(arr[11]);
        that.endMonthProduct = new Date(arr[0]);
        that.changeMonthStart(null);
        that.changeMonthEnd(null);
      }
      that.showProductInfo([], true);
    },
    // 对比商品
    changeComperPro () {
      this.showProductInfo([], true);
    },
    // 打开弹出框、请求时间段分析
    showProductInfo (option, flag = false) {
      let that = this;
      loading1 = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector("#productDialogID .el-dialog")
      });

      let beginDate = null;
      let endDate = null;
      let activeName = that.activeName;
      let searchType = 0;
      if (activeName == "first" || activeName == "third") {
        beginDate = common.getDateTime(that.startTimeProduct);
        endDate = common.getDateTime(that.endTimeProduct);
      } else if (activeName == "second") {
        beginDate = common.getMonthDetail(that.startMonthProduct);
        endDate = common.getMonthDetail(that.endMonthProduct);
        searchType = 1;
      }

      if (!flag) {
        that.productDialogVisible = true;
        that.currentOption = option;
        that.valueComperProduct = [];
      }
      let currentOption = that.currentOption;
      that.productName = currentOption.Product_Name;
      that.ID = currentOption.ID;
      that.widthPro = $(".productHeader").width();
      that.legendData = [];
      that.xAxisData = [];
      that.seriesData = [];

      let data = {
        searchType: searchType, // 0按日 1按月
        beginDate: beginDate,
        endDate: endDate,
        mainProductId: currentOption.ID,
        productId: that.valueComperProduct,
        resType: that.resType //resType  0金额 1数量 2店均量
      };
      that.getProductSalesTime(data).then(
        res => {
          console.log(res);
          let legendData = [];
          let xAxisData = [];
          let seriesData = [];
          let averMoney = res.averMoney;
          let dataAver = [];
          res.item.map((item, index) => {
            let arr = that.tableData.filter(proItem => {
              return item.productId == proItem.ID;
            });
            let name = arr.length > 0 ? arr[0].Product_Name : "";
            legendData.push(name);
            let data = item.salesItem.map(opt => {
              if (index + 1 == res.item.length) {
                dataAver.push(averMoney);
                xAxisData.push(
                  activeName == "first" || activeName == "third"
                    ? common.getTime(opt.salesDate)
                    : common.getMonth(opt.salesDate)
                );
              }
              return opt.salesMoney;
            });
            seriesData.push({
              name: name,
              type: "line",
              data: data,
              symbolSize: 6, //拐点圆的大小
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2.5
                  }
                }
              }
            });
            if (index + 1 == res.item.length) {
              legendData.push("平均值");
              seriesData.push({
                name: "平均值",
                type: "line",
                data: dataAver,
                symbolSize: 6, //拐点圆的大小
                itemStyle: {
                  normal: {
                    lineStyle: {
                      width: 2.5
                    }
                  }
                }
              });
            }
          });
          that.legendData = legendData;
          that.seriesData = seriesData;
          that.xAxisData = xAxisData;

          setTimeout(function () {
            that.drawLine();
            that.$nextTick(() => {
              loading1.close();
            });
          }, 200);
        },
        err => {
          that.$nextTick(() => {
            loading1.close();
          });
        }
      );
    },
    showProductTypeInfo (option, flag = false) {
      let that = this;
      if (!flag) {
        that.currentOption = option;
        that.productTypeNameCurrent = that.currentOption.PRODUCT_TYPE_NAME;
        that.productTypeIdCurrent = that.currentOption.PRODUCT_TYPE_ID;
        that.productTypeDialogVisible = true;
      }
    },
    closeProductTypeInfo () {
      let that = this;
      that.productTypeDialogVisible = false;
    },
    getProductSalesTime (data) {
      return new Promise((resolve, reject) => {
        productApi
          .getProductABCSalesTime(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    saveABCFun (data) {
      return new Promise((resolve, reject) => {
        productApi
          .saveABC(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    drawLine () {
      //销量
      let that = this;
      // 基于准备好的dom，初始化echarts实例
      myChart = that.$echarts.init(document.getElementById("myChart"));
      myChart.clear();
      let legendData = that.legendData;
      let seriesData = that.seriesData;
      let xAxisData = that.xAxisData;
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function (params, ticket, callback) {
            let str = params[0].name += '<br/>'
            for (var i = 0, l = params.length; i < l; i++) {
              str += ('<div style="display:flex;padding-right:8px;"><div style="width:100px;text-align: right;overflow: hidden;margin-right: 8px;">' + params[i].marker + params[i].seriesName + " : </div><div>" + (params[i].data != null ? params[i].data : '') + '</div></div>');
            }
            return str
          }
        },
        legend: {
          right: "3%",
          data: legendData
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {
          type: "value"
        },
        color: [
          "#f51f0e",
          "#ff9804",
          "#ffe900",
          "#adea00",
          "#00e676",
          "#4cae50",
          "#00e5ff",
          "#43a5f4",
          "#2862ff",
          "#de40fb",
          "#ff75a4",
          "#cccccc"
        ],
        series: seriesData
      });
    },
    //定义导出Excel表格事件
    exportExcel () {
      let that = this;
      if (that.tableData.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先查找数据！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      // const loading = that.$loading({
      //   lock: true,
      //   text: "导出中",
      //   spinner: "el-icon-loading",
      //   background: "rgba(255, 255, 255, 0.5)"
      // });
      that.centerDialogVisible = true;
      var iSpeed = 1;
      that.percentage = 0;
      that.percenttxt =
        "导出数据" + that.tableData.length + "条，已处理0条，正在导出,请稍等";
      var obj = setInterval(function () {
        iSpeed += 6;
        if (iSpeed >= 100) {
          // 设置达到多少进度后停止
          that.percentage = 100;
          that.percenttxt = "导出数据" + that.tableData.length + "条，已完成！";
          clearInterval(obj);
          setTimeout(() => {
            // loading.close();
            that.centerDialogVisible = false;
          }, 200);
        } else {
          that.percentage = iSpeed;
          that.percenttxt =
            "导出数据" +
            that.tableData.length +
            "条，已处理" +
            parseInt(that.tableData.length * (iSpeed / 100)) +
            "条，正在导出，请稍等";
        }
      }, 12); // 20毫秒后函数执行一次
      // percentage:0,
      // percenttxt:'导出数据100条,已处理50条,正在导出,请稍等',
      /* 从表生成工作簿对象 */

      // var name = document.querySelector('.el-popover');
      // var wb
      // if (name) {
      let arr = []
      // document.querySelector("#out-table .cell>span").removeChild(name);
      $('#out-table .cell>span').each(function () {
        var name = this.querySelector('.el-popover');
        arr.push(name)
        if (name) {
          this.removeChild(name);
        }
      });
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
        raw: true
      })
      // document.querySelector("#out-table .cell>span").appendChild(name);
      var i = 0
      $('#out-table .cell>span').each(function () {
        var name = arr[i]
        if (name) {
          this.appendChild(name);
        }
        i++
      });
      // } else {
      //   wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
      //     raw: true
      //   })
      // }
      // var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"),
      //   {
      //     raw: true
      //   }
      // );
      //1、获取所有的键组成的字符串数组：
      let keys = Object.keys(wb.Sheets.Sheet1);
      //2、随机获取一个合法的下标
      var len = Math.ceil(keys.length / 2) - 1;
      var sheet1 = wb.Sheets.Sheet1;
      //3、显示键的名字和键对应的值
      for (var i = len; i < keys.length - 2; i++) {
        delete sheet1[keys[i]];
      }
      wb.Sheets.Sheet1 = sheet1;
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "商品ABC" + common.getDateDetail() + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }

      return wbout;
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "color:#4e9bed";
      } else {
        return "";
      }
    },
    changeStart () {
      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: time => {
          return time.getTime() > this.endTime;
        }
      });
    },
    changeEnd () {
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: time => {
          return time.getTime() < this.startTime;
        }
      });
    },
    changeProductStart (opt) {
      let that = this;
      that.productOptionsStart = Object.assign({}, that.productOptionsStart, {
        disabledDate: time => {
          return time.getTime() > new Date(that.endTimeProduct);
        }
      });
      if (opt != null) {
        that.showProductInfo([], true);
      }
    },
    changeProductEnd (opt) {
      let that = this;
      that.productOptionsEnd = Object.assign({}, that.productOptionsEnd, {
        disabledDate: time => {
          return time.getTime() < new Date(that.startTimeProduct);
        }
      });
      if (opt != null) {
        that.showProductInfo([], true);
      }
    },
    changeMonthStart (opt) {
      let that = this;
      that.monthOptionsStart = Object.assign({}, that.monthOptionsStart, {
        disabledDate: time => {
          return time.getTime() > new Date(that.endMonthProduct);
        }
      });
      if (opt != null) {
        that.showProductInfo([], true);
      }
    },
    changeMonthEnd (opt) {
      let that = this;
      that.monthOptionsEnd = Object.assign({}, that.monthOptionsEnd, {
        disabledDate: time => {
          return time.getTime() < new Date(that.startMonthProduct);
        }
      });
      if (opt != null) {
        that.showProductInfo([], true);
      }
    },
    //商品ABC对应分类列表
    getProductTypeList () {
      return new Promise((resolve, reject) => {
        productApi
          .getProductTypeList()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //获取商品ABC对应报废类型
    getSysCodeList () {
      return new Promise((resolve, reject) => {
        productApi
          .getSysCodeList()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取商品ABC对应商品标签表头
    getColumnsList () {
      let that = this;
      productApi.getColumnsList().then(
        res => {
          that.columnsList = res;
        },
        err => { }
      );
    },
    init () {
      let that = this;
      loading = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.6)"
      });
      Promise.all([
        common.getDept({
          "areaId": []
        }),
        that.getProductTypeList(),
        that.getSysCodeList(),
        common.getDeptArea(),
        common.getProductTypeListByFLag({ typeFlag: 1 })
      ])
        .then(
          res => {
            loading.close();
            //部门树
            let array = ["1"];
            //部门对应列表
            that.optionsDept = [
              {
                deptId: "all",
                deptName: "全选"
              }
            ].concat(res[0]);
            that.valueDept =
              res[0].length > 0
                ? that.optionsDept.map(item => {
                  return item.deptId;
                })
                : [];
            //商品ABC对应分类列表
            that.optionsProductType = [
              {
                productTypeId: "all",
                productTypeName: "全选"
              }
            ].concat(res[1]);

            that.valueProductType = //[];
              res[1].length > 0
                ? that.optionsProductType.map(item => {
                  return item.productTypeId;
                })
                : [];
            //获取商品ABC对应报废类型
            that.optionsSysCode = res[2];
            that.valueSysCodeColumn = res[2];
            that.valueSysCode =
              res[2].length > 0
                ? res[2].map(item => {
                  return item.id;
                })
                : [];

            // 区域
            that.deptAreaList = [{ id: "all", name: "全选" }].concat(res[3])
            that.areaId = that.deptAreaList.map(item => {
              return item.id
            })
            // 中类
            that.typeList1 = [{ productTypeId: "all", productTypeName: "全选" }].concat(res[4])
            that.productTypeId1 = that.typeList1.map(item => {
              return item.productTypeId
            })
            // that.getDataList();
          },
          err => {
            loading.close();
          }
        )
        .catch(error => {
          loading.close();
        });
    },
    // 加载商品ABC数据
    getDataList (flag = false) {
      let that = this;
      if (flag) {
        that.pictLoading = true;
      }
      let radio = that.radio;
      let valueRecommend = that.valueRecommend;
      let startTime = common.getTime(that.startTime) + " 00:00:00";
      let endTime = common.getTime(that.endTime) + " 23:59:59";

      if (!that.areaId || that.areaId.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择区域！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        that.pictLoading = false;
        return;
      }
      let valueProductType = that.valueProductType;
      let valueSysCode = that.valueSysCode;
      let valueDept = that.valueDept;
      if (!valueDept || valueDept.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择门店！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        that.pictLoading = false;
        return;
      }
      if (!that.productTypeId1 || that.productTypeId1.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择中类！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        that.pictLoading = false;
        return;
      }
      if (valueProductType.length == 0) {
        that.tableData = [];
        that.strProduct = [];
        that.strProduct = [];
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择小类！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        that.pictLoading = false;
        return;
      }
      if (valueSysCode.length == 0) {
        that.tableData = [];
        that.strProduct = [];
        that.strProduct = [];
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先选择报废类型！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        that.pictLoading = false;
        return;
      }

      let data = {
        rdoSignType: radio,
        cmbJY: valueRecommend,
        startDate: startTime,
        endDate: endTime,
        returnTypeItems:
          valueSysCode.length == that.optionsSysCode.length
            ? ["all"]
            : valueSysCode,
        productTypeItems: valueProductType.filter(item => item != 'all'),
        // valueProductType.length == that.optionsProductType.length
        //   ? ["all"]
        //   : valueProductType,
        deptIDItems: valueDept.filter(item => item != 'all'), //valueDept.length == that.optionsDept.length ? ["all"] : 
        abcFlag: that.setABC
      };
      productApi.getDataList(data).then(
        res => {
          that.valueSysCodeColumn = that.optionsSysCode.filter(item => {
            if (valueSysCode.includes(item.id)) {
              return item;
            }
          });
          that.strProduct = res.map((item, index) => {
            item.Product_OutPriceAmount = common.toDecimal2(
              item.Product_OutPriceAmount + ""
            );

            return item.ID;
          });
          that.ListDataItem = JSON.parse(JSON.stringify(res));
          if (that.checkedBQ) {
            that.getProductBQ(true, flag);
          } else {
            loading.close();
            if (flag) {
              that.pictLoading = false;
            }
            that.tableData = res.map(item => {
              item.Product_Price = parseFloat(item.Product_Price)
              item.RebateMoney = parseFloat(item.RebateMoney)
              item.Product_OutPrice = parseFloat(item.Product_OutPrice)
              item.Product_OutPriceAmount = parseFloat(item.Product_OutPriceAmount)
              item.XS_Amount = parseFloat(item.XS_Amount)
              item.XS_AverAmount = parseFloat(item.XS_AverAmount)
              item.XS_Money = parseFloat(item.XS_Money)
              item.Amount_Rate2 = parseFloat(item.Amount_Rate.replace('%', ''))
              item.Amount_Rate_Total2 = parseFloat(item.Amount_Rate_Total.replace('%', ''))
              item.XS_Money_Rate2 = parseFloat(item.XS_Money_Rate.replace('%', ''))
              item.XS_Money_Rate_Total2 = parseFloat(item.XS_Money_Rate_Total.replace('%', ''))
              item.Profit = parseFloat(item.Profit)
              item.XS_Profit_Rate2 = parseFloat(item.XS_Profit_Rate.replace('%', ''))
              item.Profit_Rate2 = parseFloat(item.Profit_Rate.replace('%', ''))
              for (var i in that.valueSysCodeColumn) {
                let obj = that.valueSysCodeColumn[i]
                item[obj.id + '&&'] = parseFloat(typeof (item[obj.id]) != 'undefined' ? item[obj.id].split('(')[0] : 0)
              }
              return item
            });
          }
          let strDept = ''
          that.currentDept = that.valueDept.filter(item => {
            if (item != 'all') {
              strDept += ('&' + item)
              return item
            }
          })//////////////////////待写入
          // 当前查询结果查询条件
          that.beginDateCurrent = startTime
          that.endDateCurrent = endTime
          that.deptIdCurrent = strDept
        },
        err => {
          if (flag) {
            that.pictLoading = false;
          }
          loading.close();
        }
      );
    },
    getProductBQ (val, flag = false) {
      if (val) {
        let that = this;
        let data = {
          strProduct: that.strProduct
        };
        productApi.getProductBQ(data).then(
          res => {
            if (flag) {
              that.pictLoading = false;
            }
            loading.close();
            // that.valueSysCodeColumn = that.optionsSysCode.filter(item => {
            //   if (that.valueSysCode.includes(item.id)) {
            //     return item;
            //   }
            // });
            let ListDataItem = JSON.parse(JSON.stringify(that.ListDataItem));
            let columnsList = that.columnsList;
            // 标签值
            for (var i = 0; i < res.length; i++) {
              // 循环所有商品信息
              for (var j = 0; j < ListDataItem.length; j++) {
                // 循环列
                for (var k = 0; k < columnsList.length; k++) {
                  let cItem = columnsList[k]; // 当前列
                  let str = ListDataItem[j]; // 当前商品
                  // if (ListDataItem[j].ID != cItem["field"]) {
                  //   ListDataItem[j][cItem["field"]] = "";
                  // }
                  if (
                    cItem["field"] == res[i].sysCodeId &&
                    ListDataItem[j]["ID"] == res[i].productId
                  ) {
                    ListDataItem[j][cItem["field"]] = res[i].description;
                  }
                }
              }
            }
            that.tableData = ListDataItem;
          },
          err => {
            if (flag) {
              that.pictLoading = false;
            }
            loading.close();
          }
        );
      }
    }
  },
  computed: {},
  mounted () {
    let that = this;
    that.getColumnsList();
    that.init();
    that.changeStart();
    that.changeEnd();
    that.height = $("#search-content-h").height() - 230;
  },
  destroyed () {
    if (loading) { loading.close(); }
    if (loading1) { loading1.close(); }
    if (loading2) { loading2.close(); }
  }
};
</script>
<style lang="less">
.el-table .success-row {
  background: #eef7ff;
}
</style>



// WEBPACK FOOTER //
// src/view/main/productABC.vue